export const whyChooseData = {
  headers: ['Knowledge Management Platforms', 'Rumble Fish Custom Engineering'],
  rows: [
    {
      knowledgePlatforms: 'Configure pre-built tools within platform limits',
      rumbleFish: 'Build solutions tailored to your exact requirements',
    },
    {
      knowledgePlatforms: 'Generic AI trained on common patterns',
      rumbleFish: 'Custom RAG trained on your domain and terminology',
    },
    {
      knowledgePlatforms: 'Data passes through vendor infrastructure',
      rumbleFish: 'Complete on-premises deployment',
    },
    {
      knowledgePlatforms: 'Monthly/annual subscription fees per user',
      rumbleFish: 'One-time project cost, you own everything',
    },
    {
      knowledgePlatforms: 'Vendor lock-in, migration is difficult',
      rumbleFish: 'Complete source code ownership, maintain independently',
    },
  ],
};
